var React = require('react');

function IcDownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.09 0.294922L6.5 4.87492L1.91 0.294922L0.5 1.70492L6.5 7.70492L12.5 1.70492L11.09 0.294922Z","fill":"currentColor"}));
}

IcDownChevron.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = IcDownChevron;

IcDownChevron.default = IcDownChevron;
